export const ASSESSMENT_OBJECTIVE_REMARKS_FIELD_NAME = "remarks";
export const ASSESSMENT_OBJECTIVE_ACHIEVED_FIELD_NAME = "achieved";
